import { callGraphQL, makeAPIRequest } from '../utils/request'
import type {
  EventResponse,
  FanResult,
  FanResultResponse,
  EventHubResponse,
  EventHubData,
  EventGQL
} from './events.types'
import {
  matchupPageEventInfoQuery,
  eventInProgressBySlug,
  allFanResultsByEvent,
  eventHubInfo,
  eventInfoWithTeamAndPlayers
} from './events.queries'
import { API_ENDPOINTS, WLL_ENDPOINTS } from '../utils/endpoints'
import { CURRENT_YEAR } from '../../Config/League/league.config'

/**
 * Fetch all event info for specific season
 */
export async function fetchSeasonEvents(
  season: number,
  includeCS?: boolean
): Promise<EventGQL[] | null> {
  try {
    let evRes = await makeAPIRequest(API_ENDPOINTS.SEASON_EVENTS, {
      method: 'GET',
      apiVersion: '4',
      queryParams: {
        year: season,
        includeCS: includeCS || false
      }
    })
    if(evRes?.error){
      evRes.error?.message && console.error(evRes.error?.message)
      return null
    }
    return evRes?.data
  } catch (error) {
    return null
  }
}

/**
 * Fetch event info for particular officialId
 */
export async function fetchMatchupInfoBySlugGQL(slug: string, statList: string[], year?: number): Promise<EventGQL | null> {
  try {
    const evRes = await callGraphQL<EventResponse>(matchupPageEventInfoQuery, {
      slug,
      year: year || CURRENT_YEAR,
      statList
    })
    if(!evRes?.event) return null
    return evRes?.event
  } catch (error) {
    return null
  }
}

/**
 * Fetch event info for particular slug with stats, teams, players & player stats
 */
 export async function fetchFullEventBySlugGQL(slug: string): Promise<EventGQL | null> {
  try {
    const evRes = await callGraphQL<EventResponse>(eventInfoWithTeamAndPlayers, {
      slug: slug,
    })
    if(!evRes?.event) return null
    return evRes?.event
  } catch (error) {
    return null
  }
}

/**
 * Fetch event info for particular officialId
 */
export async function fetchEventInProgressBySlugGQL(
  slug: string
): Promise<EventResponse | null> {
  try {
    return callGraphQL<EventResponse>(eventInProgressBySlug, {
      slug: slug,
    })
  } catch (error) {
    return null
  }
}

// Fan Results for Pickem / bracket
/**
 * Fetch the all fan results for specific game
 */
 export async function fetchEventHubInfo(year: number, week: number): Promise<EventHubData | null> {
  try {
    const res = await callGraphQL<EventHubResponse>(eventHubInfo, {
      year: year,
      week: week
    })
    return res.eventHub
  } catch (e) {
    console.log(e)
    return null
  }
}

// Fan Results for Pickem / bracket
/**
 * Fetch the all fan results for specific game
 */
export async function fetchFanResults(eventId: number): Promise<FanResult[]> {
  try {
    const res = await callGraphQL<FanResultResponse>(allFanResultsByEvent, {
      eventId: eventId,
    })
    return res.fanResults
  } catch (e) {
    console.log(e)
    return []
  }
}

// WOMENS LACROSSE LEAGUE //
export const fetchWLLSeasonEvents = async (year: number, includeCS?: boolean): Promise<EventGQL[] | null> => {
  try {
    let evRes = await makeAPIRequest(WLL_ENDPOINTS.SEASON_EVENTS, {
      method: 'GET',
      apiVersion: '4',
      queryParams: {
        year,
        includeCS: includeCS || false
      }
    })
    if(evRes?.error){
      evRes.error?.message && console.error(evRes.error?.message)
      return null
    }
    return evRes?.data
  } catch (error) {
    return null
  }

}